import { BaseService } from "./BaseService";
import { Configuration } from "Configuration";
import { PageTokenClient, PageTokenResult, PageTokenParameter } from "./Client";

/**
 * Service which handles the PageToken-KeepAlive.
 * @hidden
 */
export class PageTokenService extends BaseService {
    private keepAliveIntervalInstance: number;
    private timeout: number;
    private failureCount: number = 0;
    private pageToken: string;

    public get(): Promise<PageTokenResult> {
        const client = new PageTokenClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<PageTokenResult>((resolve, reject) => {
            client.get(res => resolve(res), (exception, reason) => reject(exception));
            // token.onCancelled(reason => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    /**
     * Send the keepAlive token to the server.
     */
    private sendKeepAlive(): void {
        let param: PageTokenParameter = {
            PageToken: this.pageToken
        };

        const client = new PageTokenClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        
        client.touch(param).then(
            value => {
                if (value) {
                    if (value.error || value.isSessionExpired) {
                        // CoreContext.handleServiceResult(value);
                    } else {
                        this.failureCount = 0;
                    }
                }
            },
            error => {
                this.failureCount++;
                if (this.failureCount > 5) {
                    clearInterval(this.keepAliveIntervalInstance);
                } else {
                    setTimeout(() => this.sendKeepAlive(), (1000.0 * 60.0 * this.timeout) / 3.0 / 6.0);
                }
            }
        );
    }

    /**
     * Starts the polling for the PageToken-KeepAlive.
     * @param pageToken Current PageToken.
     * @param timeout Timeout value.
     */
    public startPolling(pageToken: string, timeout: number): void {
        this.timeout = timeout;
        this.pageToken = pageToken;

        if (this.keepAliveIntervalInstance != null) {
            window.clearInterval(this.keepAliveIntervalInstance);
        }

        if (this.timeout == 0) {
            return;
        }

        this.keepAliveIntervalInstance = window.setInterval(() => this.sendKeepAlive(), (1000.0 * 60.0 * this.timeout) / 3.0);
    }

    /**
     * Stops polling for the current PageToken-KeepAlive.
     */
    public stopPolling(): void {
        if (this.keepAliveIntervalInstance != null) {
            clearInterval(this.keepAliveIntervalInstance);
        }
    }

    /**
     * Send the release token
     */
    public sendRelease(): void {
        let param: PageTokenParameter = {
            PageToken: this.pageToken
        };
        const client = new PageTokenClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        client.release(param);
        // $.ajax(Configuration.baseUrl + "pageToken/release", { type: "POST", async: false, data: param });
        // this.post(Configuration.baseUrl + "pageToken/release", param);
    }
}
